export default __webpack_public_path__ + "images/purchase/super_saver-908fcd3cd1b8b9f57c043abb236477ba.png";